import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { BranchProvider } from './context/BranchContext';
import { ThemeProvider } from './context/ThemeContext';
import { NotificationProvider } from './context/NotificationContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import Businesses from './pages/Businesses';
import Branches from './pages/Branches';
import BusinessBranches from './pages/BusinessBranches';
import BusinessUsers from './pages/BusinessUsers';
import BusinessDetails from './pages/BusinessDetails';
import BranchDetails from './pages/BranchDetails';
import Parties from './pages/Parties';
import Salary from './pages/Salary';
import Products from './pages/Products';
import Sales from './pages/Sales';
import PointOfSale from './pages/PointOfSale';
import WorkOrders from './pages/WorkOrders';
import Purchases from './pages/Purchases';
import ProfitLoss from './pages/ProfitLoss';
import DailyInOutReport from './pages/DailyInOutReport';
import Accounts from './pages/Accounts';
import DeletedParties from './pages/DeletedParties';
import DeletedProducts from './pages/DeletedProducts';
import DeletedWorkOrders from './pages/DeletedWorkOrders';
import StockTransfer from './pages/StockTransfer';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <NotificationProvider>
        <AuthProvider>
          <BranchProvider>
          <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/businesses"
              element={
                <ProtectedRoute>
                  <Businesses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/branches"
              element={
                <ProtectedRoute>
                  <Branches />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stock-transfer"
              element={
                <ProtectedRoute>
                  <StockTransfer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/businesses/:businessId/branches"
              element={
                <ProtectedRoute>
                  <BusinessBranches />
                </ProtectedRoute>
              }
            />
            <Route
              path="/businesses/:businessId/users"
              element={
                <ProtectedRoute>
                  <BusinessUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/businesses/:id/details"
              element={
                <ProtectedRoute>
                  <BusinessDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/branches/:id/details"
              element={
                <ProtectedRoute>
                  <BranchDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/parties"
              element={
                <ProtectedRoute>
                  <Parties />
                </ProtectedRoute>
              }
            />
            <Route
              path="/salary"
              element={
                <ProtectedRoute>
                  <Salary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/products"
              element={
                <ProtectedRoute>
                  <Products />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales"
              element={
                <ProtectedRoute>
                  <Sales />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pos"
              element={
                <ProtectedRoute>
                  <PointOfSale />
                </ProtectedRoute>
              }
            />
            <Route
              path="/work-orders"
              element={
                <ProtectedRoute>
                  <WorkOrders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/purchases"
              element={
                <ProtectedRoute>
                  <Purchases />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profit-loss"
              element={
                <ProtectedRoute>
                  <ProfitLoss />
                </ProtectedRoute>
              }
            />
            <Route
              path="/daily-inout-report"
              element={
                <ProtectedRoute>
                  <DailyInOutReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/accounts"
              element={
                <ProtectedRoute>
                  <Accounts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/deleted/parties"
              element={
                <ProtectedRoute>
                  <DeletedParties />
                </ProtectedRoute>
              }
            />
            <Route
              path="/deleted/products"
              element={
                <ProtectedRoute>
                  <DeletedProducts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/deleted/work-orders"
              element={
                <ProtectedRoute>
                  <DeletedWorkOrders />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
          </BranchProvider>
      </AuthProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
